<script setup lang="ts">
import type { ContainerElement } from './types';
import ContainerElementComponent from './components/Container.vue';

const { t } = useI18n();

defineProps<{
    container: ContainerElement;
}>();


</script>
<template>
    <div class="flex flex-col h-full overflow-y-auto">
        <div class="flex py-4 justify-between">
            <h3 class="font-light">
                {{ t('formBuilder.formCanvasHeader') }}
            </h3>
        </div>

        <container-element-component
            root
            class="h-full"
            :element="container"
        />
    </div>
</template>
